import React from 'react'
import { DetailEmptyState } from './detail'

/** Shared empty placeholder — keep message-only API for existing call sites. */
export const EmptyState = ({
  message,
  title,
  action,
}: {
  message: string
  title?: string
  action?: React.ReactNode
}) => <DetailEmptyState title={title} message={message} action={action} />
